import { userSelectors, userActions, userThunks as defaultThunks, userReducer } from './user-slice';
import * as thunks from './user-thunks';

const userThunks = { ...defaultThunks, ...thunks };

export { userSelectors, userActions, userThunks, userReducer };
